import { render, staticRenderFns } from "./PurchasingUnitLabel.vue?vue&type=template&id=46e7be28&"
import script from "./PurchasingUnitLabel.vue?vue&type=script&lang=js&"
export * from "./PurchasingUnitLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports